import { CnpjValidator } from '../../../../shared/utils/validators/cnpj-validator';
import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from "@angular/core";
import {
  AbstractControl,
  FormArray,
  FormControl,
  FormGroup,
  ValidationErrors,
  ValidatorFn,
  Validators,
} from "@angular/forms";
import { Router } from "@angular/router";
import { ISignUpResult } from "amazon-cognito-identity-js";
import { cnpj, cpf } from "cpf-cnpj-validator";
import * as moment from "moment";
import {
  MDBModalRef,
  MDBModalService,
  MdbStepperComponent,
} from "ng-uikit-pro-standard";
import { ModalTermoPrivacidadeComponent } from "src/app/portal/components/modal-termo-privacidade/modal-termo-privacidade.component";
import { PasswordValidator } from "src/app/portal/utils/password-validator";
import { CognitoAttributes } from "src/app/shared/enum/cognito.enum";
import { CognitoService } from "src/app/shared/services/cognito.service";
import { DdiService } from "src/app/shared/services/ddi.service";
import { arrayEstados, Estados } from "src/app/shared/utils/data/estados.data";
import {
  showDefaultError,
  showError,
  showErrorAndNavigateToHome,
  showErrorViaArray,
  showSucess,
} from "src/app/shared/utils/functions/notification.function";
import {
  cnpjValidator,
  cpfValidator,
  emailConfirmValidator,
  emailValidator,
  passwordConfirmValidator,
  passwordValidator,
  termsValidator,
  validateTelOrCell,
} from "src/app/shared/utils/validators/forms.validators";
import { safeAsign } from "src/app/shared/utils/functions/safe-asign.function";
import Swal from "sweetalert2";

import { Empresa, Representantes } from "../../../models/empresa.model";
import { Entidade, Responsabile } from "../../../models/entidade.model";
import { Investidor } from "../../../models/investidor.model";
import { ISignUpEmpresas } from "../../../models/register.model";
import { CadastroService } from "../../../services/cadastro.service";
import { InvestorType, UserType } from "src/app/shared/enum/investor-type.enum";
import { TokenStatus } from 'src/app/shared/components/token-input/token-input.component';

@Component({
  selector: "app-cadastro-usuario",
  templateUrl: "./cadastro-usuario.component.html",
  styleUrls: ["./cadastro-usuario.component.scss"],
})
export class CadastroUsuarioComponent implements OnInit {
  @Input() typeForm: InvestorType;
  @Output() voltar = new EventEmitter<void>();

  // Props Componentes
  @ViewChild("stepper", { static: false }) stepper: MdbStepperComponent;
  @ViewChild("stepperPF", { static: false }) stepperPF: MdbStepperComponent;
  @ViewChild("stepperEntidade", { static: false }) stepperEntidade: MdbStepperComponent;

  modalRef: MDBModalRef;

  // Formulários
  formInvestidorPJ: FormGroup;
  formInvestidorPF: FormGroup;
  formEmpresa: FormGroup;
  formToken: FormGroup;
  formFundoInvestimento: FormGroup;

  formResponsavelEntidade: FormGroup;
  formEntity: FormGroup;

  formEnderecoEntidade: FormGroup;

  //cShared Utils
  tableDdi = [];
  responseTermo: any;
  showPassword: boolean = false;
  arrayEstados: Estados[] = arrayEstados;
  disableButton = "reenviar-codigo";

  // Validator Errors
  hasError: boolean = false;
  tokenValidado: boolean = false;
  exibirFormulario: boolean = false;
  permiteProximo = "invalid";
  tokenValidar: string = "";
  editavel: boolean = false;
  maiorDeIdade: boolean = true;
  tokenStatus: TokenStatus = "idle";
  validating: boolean = false;

  // Controle de geração de tokens na etapa "Dados do Responsável pelo Cadastro da Empresa"
  nextDisabled: boolean = false;
  tokenGerado: boolean = false;

  constructor(
    private ddiService: DdiService,
    private cadastroService: CadastroService,
    private modalService: MDBModalService,
    private cognitoService: CognitoService,
    private router: Router
  ) {}

  ngOnInit() {
    this.createForms();
    // this.listarDDI(); //Erro 401 Unauthorized
    this.formInvestidorPJ.valueChanges.subscribe((value) => {
      this.nextDisabled = false;
    });
    this.incapazPF?.valueChanges.subscribe(() => {
      this.updateResponsavelValidatorsPF();
    });
  }

  // Functions Global
  backStep() {
    this.voltar.emit();
  }

  async nextStep() {
    if (
      [InvestorType.PJ, InvestorType.Investment].includes(
        this.typeForm as InvestorType
      )
    ) {
      if (this.validateFormInvestidorPJ()) {
        this.nextDisabled = true;
        await this.cognitoService
          .checkUser(this.documentoIdentificadorPJ.value)
          .then(() => {
            const {
              documentoIdentificador,
              nome,
              email,
              senha,
              dataNascimento
            } =
              this.formInvestidorPJ.value;

            if (!this.tokenGerado) {
              this.cognitoService
                .signUp(documentoIdentificador, senha, {
                  [CognitoAttributes.FamilyName]: nome,
                  [CognitoAttributes.Name]: nome,
                  [CognitoAttributes.Email]: email,
                  [CognitoAttributes.Birthdate]: dataNascimento,
                  [CognitoAttributes.TipoUsuario]:
                    this.typeForm === InvestorType.PJ
                      ? UserType.InvestmentPj
                      : UserType.InvestmentFund,
                })
                .subscribe(
                  (res: ISignUpResult) => {
                    this.tokenValidado = res.userConfirmed;
                    this.exibirFormulario = true;
                    this.tokenGerado = true;
                    return this.stepper.next();
                  },
                  (err: Error) => {
                    return showErrorAndNavigateToHome(
                      this.router,
                      "",
                      err.message
                    );
                  }
                );
            } else {
              return this.stepper.next();
            }
          })
          .catch((err) => {
            showErrorAndNavigateToHome(
              this.router,
              "",
              "Erro ao validar usuário."
            );
          });
      }
    } else if (this.typeForm === InvestorType.Entity) {
      if (this.validateFormResponsavelEntidade()) {
        this.nextDisabled = true;
        const {
          documentoIdentificador,
          nomeContato,
          email,
          senha,
          dataNascimento
        } =
          this.formResponsavelEntidade.value;

        if (!this.tokenGerado) {
          this.cognitoService
            .signUp(documentoIdentificador, senha, {
              [CognitoAttributes.Email]: email,
              [CognitoAttributes.FamilyName]: nomeContato,
              [CognitoAttributes.TipoUsuario]: UserType.Entity,
              [CognitoAttributes.Birthdate]: dataNascimento,
            })
            .subscribe(
              (res: ISignUpResult) => {
                this.tokenValidado = res.userConfirmed;
                this.exibirFormulario = true;
                this.tokenGerado = true;
                return this.stepperEntidade.next();
              },
              (err: Error) => {
                return showErrorAndNavigateToHome(this.router, "", err.message);
              }
            );
        } else {
          return this.stepperEntidade.next();
        }
      }
    } else {
      if (this.validateFormInvestidorPF()) {
        this.nextDisabled = true;
        const {
          documentoIdentificador,
          senha,
          nome,
          email,
          codigoDdi,
          telefone,
          celular,
          dataNascimento,
          documentoResponsavel,
          nomeResponsavel,
          incapz,
        } = this.formInvestidorPF.getRawValue();

        if (!this.tokenGerado) {
          this.cognitoService
            .signUp(documentoIdentificador, senha, {
              [CognitoAttributes.FamilyName]: nome,
              [CognitoAttributes.Name]: nome,
              [CognitoAttributes.Email]: email,
              [CognitoAttributes.DDINumber]: codigoDdi,
              [CognitoAttributes.PhoneNumber]: telefone == "" ? "" : `${codigoDdi}${telefone}`,
              [CognitoAttributes.CellNumber]: `${codigoDdi}${celular}`,
              [CognitoAttributes.Birthdate]: dataNascimento,
              [CognitoAttributes.Unable]: incapz,
              [CognitoAttributes.ResponsibleDocument]: documentoResponsavel,
              [CognitoAttributes.ResponsibleName]: nomeResponsavel,
              [CognitoAttributes.TipoUsuario]: UserType.InvestmentPf,
            })
            .subscribe(
              (res: ISignUpResult) => {
                this.tokenValidado = res.userConfirmed;
                this.exibirFormulario = true;
                this.tokenGerado = true;
                return this.stepperPF.next();
              },
              (err: Error) => {
                return showErrorAndNavigateToHome(this.router, "", err.message);
              }
            );
        } else {
          return this.stepperPF.next();
        }
      }
    }
  }

  nextStepEmail() {
    if (this.formToken.invalid) {
      this.tokenStatus = "error";
      return;
    }

    this.validating = true;
    this.tokenStatus = "idle";

    if (!this.formToken.invalid) {
      const tokenValidar = this.token.value;
      const documento =
        this.typeForm == InvestorType.PF
          ? this.documentoIdentificadorPF.value
          : this.typeForm == InvestorType.Entity
          ? this.documentoIdentificadorResponsavelEntidade.value
          : this.documentoIdentificadorPJ.value;

      this.cognitoService.confirmAccount(tokenValidar, documento).subscribe(
        (res) => {
          this.tokenValidado = true;
          this.tokenStatus = "success";

          if (
            [InvestorType.PJ, InvestorType.Investment, InvestorType.Entity].includes(
              this.typeForm as InvestorType
            )
          ) {

            this.nextDisabled = false;

            const { documentoIdentificador, senha } =
              this.typeForm === InvestorType.Entity
                ? this.formResponsavelEntidade.value
                : this.formInvestidorPJ.value;
            const proximoStepper =
              this.typeForm === InvestorType.Entity
                ? this.stepperEntidade
                : this.stepper;

            this.cognitoService.signIn(documentoIdentificador, senha).subscribe(
              (res) => {
                this.validating = false;
                switch (res) {
                  case "":
                    return setTimeout(() => proximoStepper.next(), 800);
                  case "newPassword":
                    this.router.navigate(["reset/senha"]);
                    break;
                  case "alertInvestidor":
                    Swal.fire({
                      title: "Este canal é exclusivo para Pessoa Jurídica!",
                      html:
                        "<p>Se deseja solicitar ou consultar o status de sua garantia de Pessoa Física " +
                        "Pessoa Física, utilize o aplicativo <b>FGC</b>.</p>" +
                        'Caso as dúvidas persistam, encaminhe um e-mail para <a href="mailto:atendimento.credores@fgc.org.br">atendimento.credores@fgc.org.br</a>',
                      icon: "error",
                      confirmButtonText: "ok",
                    });
                    break;
                }
              },
              (e) => {
                this.validating = false;
                if (e.status == 400 || e.status == 422)
                  return showDefaultError(e);

                switch (e.name) {
                  case "NotAuthorizedException":
                    showError("", "CPF ou senha incorreta.");
                    break;
                  default:
                    showError("", "Ocorreu uma falha durante a autenticação.");
                    break;
                }
              }
            );
          } else if (this.typeForm === InvestorType.PF) {
            this.validating = false;
            setTimeout(() => {
              this.router.navigate(["login"]);
              return showSucess("", "Cadastro Efetuado com Sucesso.");
            }, 800);
          }
        },
        (e: Error) => {
          this.validating = false;
          this.tokenValidado = false;
          this.permiteProximo = "invalid";

          if(this.tokenError(e)) {
            this.tokenStatus = "error";
          } else {
            this.tokenStatus = "idle";
            showError("", e.message);
          }
        }
      );
    } else return showError("", "Preencha o token recebido em seu email.");
  }

  private tokenError(e: any): boolean {
    const codigo = e?.code || e?.name || '';
    return [
      "CodeMismatchException",
      "ExpiredCodeException",
    ].includes(codigo);
  }

  resendToken() {
    this.tokenStatus = "idle";

    this.disabledSendToken(true);
    setTimeout(() => {
      showSucess(
        "",
        "Um novo token foi enviado para o email informado anteriormente."
      );
      let documento =
        this.typeForm == InvestorType.PF
          ? this.documentoIdentificadorPF.value
          : this.typeForm == InvestorType.Entity
          ? this.documentoIdentificadorResponsavelEntidade.value
          : this.documentoIdentificadorPJ.value;

      this.cognitoService.resendEmailCode(documento).subscribe(
        (res) => {
          this.tokenValidado = false;
        },
        (e: Error) => {
          this.disabledSendToken(true);
          return showError(
            "",
            "Ocorreu um erro na solicitação, por favor tente novamente em alguns instantes"
          );
        },
        () => this.disabledSendToken(false)
      );
    }, 1000);
  }

  resetStep() {
    this.nextDisabled = false;
    this.token.setValue("");
    if (this.typeForm == InvestorType.PF) {
      this.stepperPF.previous();
    } else if (this.typeForm == InvestorType.Entity) {
      this.stepperEntidade.previous();
    } else {
      this.stepper.previous();
    }
  }

  private listarDDI() {
    this.ddiService.consultaDDI().subscribe(
      (res) => (this.tableDdi = res.data.ddis),
      (e) => showError("", "Erro ao realizar a listagem de DDI'S")
    );
  }

  private disabledSendToken(param: boolean) {
    this.disableButton = param ? "disabled-token" : "reenviar-codigo";
  }

  private exibirModalTermo() {
    const config = {
      ignoreBackdropClick: true,
      data: { model: this.responseTermo },
      scroll: true,
    };

    this.modalRef = this.modalService.show(
      ModalTermoPrivacidadeComponent,
      config
    );
  }

  // Functions PJ
  cadastrarEmpresas() {
    if (this.validateFormEmpresa()) {
      const body: ISignUpEmpresas = {
        documentoIdentificador: this.documentoIdentificadorPJ?.value,
        empresas: this.formEmpresa.getRawValue().empresas.map((emp) => ({
          cnpj: emp.cnpj,
          nomeEmpresa: emp.nomeEmpresa,
          representantes: emp.representantes.map((rep) => ({
            nome: rep.nome,
            cpf: rep.cpf,
            emailPj: rep.emailPj,
          })),
        })),
      };

      this.cadastroService.efetuarCadastroEmpresas(body).subscribe(
        (res) => {
          this.router.navigate(["login"]);
          return showSucess("", "Cadastro Efetuado com Sucesso.");
        },
        (e) => {
          if (e) {
            const errors = e?.error?.descricaoErro || [];
            return showErrorViaArray("", errors);
          } else {
            return showError(
              "",
              "Ocorreu um erro na solicitação, por favor tente novamente em alguns instantes."
            );
          }
        }
      );
    }
  }

  addEmpresa(remove: boolean = false): void {
    this.empresasPJ.push(this.createFormEmpresa(new Empresa(), remove));
  }

  removeEmpresa(index: number): void {
    this.empresasPJ.removeAt(index);
  }

  // Functions Entidade
  cadastrarEntidade() {
    if (this.validateFormEntidade()) {
      this.nextDisabled = false;
      const cpf = this.documentoIdentificadorResponsavelEntidade.value;
      const {
        documentoIdentificador,
        razaoSocial,
        codigoDdi,
        telefone,
        celular,
        tipoEntidade,
      } = this.formEntity.getRawValue();

      this.cognitoService
        .update({
          username: cpf,
          [CognitoAttributes.ContactName]: razaoSocial,
          [CognitoAttributes.DDINumber]: codigoDdi,
          [CognitoAttributes.PhoneNumber]:
            telefone == "" ? "" : `${codigoDdi}${telefone}`,
          [CognitoAttributes.CellNumber]:
            celular == "" ? "" : `${codigoDdi}${celular}`,
          [CognitoAttributes.TypeEntity]: tipoEntidade,
          [CognitoAttributes.Cnpj]: documentoIdentificador,
        })
        .subscribe(
          (res) => {
            this.router.navigate(["login"]);
            return showSucess("", "Cadastro Efetuado com Sucesso.");
          },
          (err: Error) => {
            this.nextDisabled = false;
            return showErrorAndNavigateToHome(this.router, "", err.message);
          }
        );
    }
  }

  // Forms
  private createForms() {
    this.createTokenForm(this.tokenValidar);
    this.createFormPj(new Investidor());
    this.createFormPF(new Investidor());
    this.createFormArrayEmpresa([]);
    this.addEmpresa(true);
    this.createFormResponsavelEntidade(new Responsabile());
    this.createFormEntity(new Entidade());
  }

  private createTokenForm(token: string) {
    this.formToken = new FormGroup({
      token: new FormControl(token, [
        Validators.required,
        Validators.maxLength(6),
        // TokenValidator.token
      ]),
    });
  }

  // Forms PJ
  private createFormPj(investidor: Investidor) {
    this.formInvestidorPJ = new FormGroup(
      {
        nome: new FormControl(investidor.nome || "", [Validators.required]),
        documentoIdentificador: new FormControl(
          investidor.documentoIdentificador || "",
          [
            Validators.required,
            Validators.minLength(11),
            Validators.maxLength(14),
            cpfValidator,
          ]
        ),
        dataNascimento: new FormControl(investidor.dataNascimento || "", [
          Validators.required,
          this.validateAgeControl(),
        ]),
        email: new FormControl(investidor.email || "", [
          Validators.required,
          Validators.email,
          Validators.minLength(5),
          Validators.maxLength(50),
          emailValidator,
        ]),
        confirmaEmail: new FormControl("", [
          Validators.required,
          Validators.email,
        ]),
        senha: new FormControl(investidor.senha || "", [
          Validators.required,
          Validators.minLength(8),
          PasswordValidator.strong,
          passwordValidator,
        ]),
        confirmaSenha: new FormControl("", [
          Validators.required,
          Validators.minLength(8),
        ]),
        termoAceite: new FormControl(investidor.termoAceite || false, [
          Validators.required,
          termsValidator,
        ]),
      },
      { validators: [emailConfirmValidator, passwordConfirmValidator] }
    );
  }

  private createFormArrayEmpresa(empresas: Empresa[]) {
    const formArray = new FormArray([]);

    if (empresas && empresas.length > 0) {
      empresas.forEach((empresa) => {
        formArray.push(this.createFormEmpresa(empresa));
      });
    }

    this.formEmpresa = new FormGroup({
      empresas: formArray,
    });
  }

  private createFormEmpresa(empresa?: Empresa, remove?: boolean) {
    return new FormGroup({
      remove: new FormControl(remove),
      cnpj: new FormControl(empresa?.cnpj || "", [
        Validators.required,
        Validators.minLength(14),
        Validators.maxLength(18),
      ]),
      nomeEmpresa: new FormControl(empresa?.nomeEmpresa || "", [
        Validators.required,
        Validators.pattern(/^[^!"?\[\\\]‘’“”«»–.]*$/),
      ]),
      representantes: new FormArray([
        this.createFormRepresentantes(empresa?.representantes?.[0], true),
        this.createFormRepresentantes(empresa?.representantes?.[1], false),
      ]),
    });
  }

  private createFormRepresentantes(representante?: Representantes, isRequired = true) {
    const validarNome = isRequired ? [Validators.required, Validators.minLength(3)] : [Validators.minLength(3)];
    const validarCpf = isRequired ? [Validators.required, Validators.minLength(11), Validators.maxLength(14)] : [Validators.minLength(11), Validators.maxLength(14)];
    const validarEmail = isRequired ? [Validators.required, Validators.maxLength(50), emailValidator] : [Validators.maxLength(50), emailValidator];

    return new FormGroup({
      nome: new FormControl(representante?.nome || "", validarNome),
      cpf: new FormControl(representante?.cpf || "", validarCpf),
      emailPj: new FormControl(representante?.emailPj || "", validarEmail),
    });
  }

  // Forms PF
  private createFormPF(investidor: Investidor) {
    this.formInvestidorPF = new FormGroup(
      {
        documentoIdentificador: new FormControl(
          investidor.documentoIdentificador || "",
          [
            Validators.required,
            Validators.minLength(11),
            Validators.maxLength(14),
            cpfValidator,
          ]
        ),
        nome: new FormControl(investidor.nome || "", [
          Validators.required,
          Validators.minLength(5),
          Validators.maxLength(150),
        ]),
        email: new FormControl(investidor.email || "", [
          Validators.required,
          Validators.email,
          Validators.minLength(5),
          Validators.maxLength(50),
          emailValidator,
        ]),
        confirmaEmail: new FormControl("", [
          Validators.required,
          Validators.email,
        ]),
        senha: new FormControl(investidor.senha || "", [
          Validators.required,
          Validators.minLength(8),
          PasswordValidator.strong,
          passwordValidator,
        ]),
        confirmaSenha: new FormControl("", [
          Validators.required,
          Validators.minLength(8),
        ]),
        codigoDdi: new FormControl(investidor.codigoDdi || "", [
          Validators.required,
        ]),
        telefone: new FormControl(investidor.telefone || ""),
        celular: new FormControl(investidor.celular || ""),
        termoAceite: new FormControl(investidor.termoAceite || false, [
          Validators.required,
          termsValidator,
        ]),
        dataNascimento: new FormControl(investidor.dataNascimento || "", [
          Validators.required,
          this.validateAgeControl(),
        ]),
        documentoResponsavel: new FormControl(
          investidor.documentoResponsavel || ""
        ),
        nomeResponsavel: new FormControl(investidor.nomeResponsavel || ""),
        incapaz: new FormControl(investidor.incapaz || false),
      },
      {
        validators: [
          emailConfirmValidator,
          passwordConfirmValidator,
          validateTelOrCell,
        ],
      }
    );
  }

  // Forms Entidade
  private createFormResponsavelEntidade(responsabile: Responsabile) {
    this.formResponsavelEntidade = new FormGroup(
      {
        documentoIdentificador: new FormControl(
          responsabile.documentoIdentificador || "",
          [
            Validators.required,
            Validators.minLength(11),
            Validators.maxLength(14),
            cpfValidator,
          ]
        ),
        nomeContato: new FormControl(responsabile.nomeContato || "", [
          Validators.required,
          Validators.minLength(5),
          Validators.maxLength(150),
        ]),
        dataNascimento: new FormControl(responsabile.dataNascimento || "", [
          Validators.required,
          this.validateAgeControl(),
        ]),
        email: new FormControl(responsabile.email || "", [
          Validators.required,
          Validators.email,
          Validators.minLength(5),
          Validators.maxLength(50),
          emailValidator,
        ]),
        confirmaEmail: new FormControl("", [
          Validators.required,
          Validators.email,
        ]),
        senha: new FormControl(responsabile.senha || "", [
          Validators.required,
          Validators.minLength(8),
          PasswordValidator.strong,
          passwordValidator,
        ]),
        confirmaSenha: new FormControl("", [
          Validators.required,
          Validators.minLength(8),
        ]),
        termoAceite: new FormControl(responsabile.termoAceite || false, [
          Validators.required,
          termsValidator,
        ]),
      },
      {
        validators: [emailConfirmValidator, passwordConfirmValidator],
      }
    );
  }

  private createFormEntity(entity: Entidade) {
    this.formEntity = new FormGroup(
      {
        tipoEntidade: new FormControl(entity.tipoEntidade || "", [
          Validators.required,
        ]),
        documentoIdentificador: new FormControl(
          entity.documentoIdentificador || "",
          [
            Validators.required,
            Validators.minLength(11),
            Validators.maxLength(14),
            cnpjValidator,
          ]
        ),
        razaoSocial: new FormControl(entity.razaoSocial || "", [
          Validators.required,
          Validators.minLength(5),
          Validators.maxLength(150),
          Validators.pattern(/^[^!"?\[\\\]‘’“”«»–.]*$/),
        ]),
        codigoDdi: new FormControl(entity.codigoDdi || "", [
          Validators.required,
        ]),
        telefone: new FormControl(entity.telefone || "", [
          Validators.minLength(10),
        ]),
        celular: new FormControl(entity.celular || "", [
          Validators.minLength(11),
        ]),
      },
      {
        validators: [validateTelOrCell],
      }
    );
  }

  private createFormTipoInvestimento(investidor: Investidor) {
    this.formInvestidorPF = new FormGroup({
      documentoIdentificador: new FormControl(
        investidor.documentoIdentificador,
        [Validators.required]
      ),
      nome: new FormControl(investidor.nome, [
        Validators.required,
        Validators.minLength(5),
        Validators.maxLength(150),
      ]),
      email: new FormControl(investidor.email, [
        Validators.required,
        Validators.email,
        Validators.minLength(5),
        Validators.maxLength(50),
      ]),
      confirmaEmail: new FormControl("", [
        Validators.required,
        Validators.email,
      ]),
      senha: new FormControl(investidor.senha, [
        Validators.required,
        Validators.minLength(8),
        PasswordValidator.strong,
      ]),
      confirmaSenha: new FormControl("", [
        Validators.required,
        Validators.minLength(8),
      ]),
      codigoDdi: new FormControl(investidor.codigoDdi, [Validators.required]),
      telefone: new FormControl(investidor.telefone),
      celular: new FormControl(investidor.celular),
      termoAceite: new FormControl(investidor.termoAceite, [
        Validators.required,
      ]),
      dataNascimento: new FormControl(investidor.dataNascimento),
      documentoResponsavel: new FormControl(investidor.documentoResponsavel),
      nomeResponsavel: new FormControl(investidor.nomeResponsavel),
      incapaz: new FormControl(investidor.incapaz),
    });
  }

  //Validate FORMS
  private validateFormInvestidorPJ(): boolean {
    if (this.documentoIdentificadorPJ.hasError("cpfInvalid")) {
      showError("", "Infome um CPF Válido.");
      return false;
    }

    if (this.emailPJ.hasError("emailInvalid")) {
      showError("", "Informe um E-mail válido.");
      return false;
    }

    if (this.dataNascimentoPJ.invalid) {
      showError("", 'O campo "Data Nascimento" é obrigatório.');
      return false;
    }

    if (this.formInvestidorPJ.errors?.confirmEmailRequired) {
      showError("", "Confirme o email informado.");
      return false;
    }

    if (this.formInvestidorPJ.errors?.diffEmails) {
      showError("", "Os emails informados não coincidem.");
      return false;
    }

    if (this.senhaPJ.hasError("invalidPassword")) {
      showError("", "Informe uma PJ.");
      return false;
    }

    if (this.senhaPJ.hasError("weakPassword")) {
      showError(
        "",
        "Sua senha precisa ter no mínimo 8 caracteres, 1 letra maiúscula, 1 letra minúscula, 1 caractere especial e 1 número."
      );
      return false;
    }

    if (this.formInvestidorPJ.errors?.confirmPasswordRequired) {
      showError("", "Confirme sua senha.");
      return false;
    }

    if (this.formInvestidorPJ.errors?.diffPasswords) {
      showError("", "As senhas informadas não coincidem.");
      return false;
    }

    if (this.termPJ.hasError("termNotAccepted")) {
      showError(
        "",
        "Você deve concordar com a Política de Privacidade antes de prosseguir."
      );
      return false;
    }

    if (this.formInvestidorPJ.invalid) {
      showError(
        "Campos obrigatórios não preenchidos corretamente.",
        "Campos obrigatórios não preenchidos corretamente. Revise o formulário novamente para prosseguir."
      );
      return false;
    }

    return true;
  }

  private validateFormInvestidorPF(): boolean {
    if (this.documentoIdentificadorPF.hasError("cpfInvalid")) {
      showError("", "Infome um CPF Válido.");
      return false;
    }

    if (this.emailPF.hasError("emailInvalid")) {
      showError("", "Informe um E-mail válido.");
      return false;
    }

    if (this.formInvestidorPF.errors?.confirmEmailRequired) {
      showError("", "Confirme o email informado.");
      return false;
    }

    if (this.formInvestidorPF.errors?.diffEmails) {
      showError("", "Os emails informados não coincidem.");
      return false;
    }

    if (this.formInvestidorPF.errors?.telOrCellRequired) {
      showError(
        "Telefone ou celular não informado",
        "para prosseguir informe um número de telefone ou de celular"
      );
      return false;
    }

    if (this.dataNascimentoPF.invalid) {
      showError("", 'O campo "Data Nascimento" é obrigatório.');
      return false;
    }

    if (!this.maiorDeIdade || this.incapazPF.value) {
      if (this.documentoResponsavelPF.hasError("cpfInvalid")) {
        showError(
          "erro",
          "O Documento do responsável é obrigatório para investidores que são menores de idade ou incapaz"
        );
        return false;
      }

      if (this.nomeResponsavelPF.invalid) {
        showError(
          "",
          "O nome responsável é obrigatório para investidores que são menores de idade ou incapaz"
        );
        return false;
      }
    }

    if (this.senhaPF.hasError("invalidPassword")) {
      showError("", "Informe uma senha.");
      return false;
    }

    if (this.senhaPF.hasError("weakPassword")) {
      showError(
        "",
        "Sua senha precisa ter no mínimo 8 caracteres, 1 letra maiúscula, 1 letra minúscula, 1 caractere especial e 1 número."
      );
      return false;
    }

    if (this.formInvestidorPF.errors?.confirmPasswordRequired) {
      showError("", "Confirme sua senha.");
      return false;
    }

    if (this.formInvestidorPF.errors?.diffPasswords) {
      showError("", "As senhas informadas não coincidem.");
      return false;
    }

    if (this.termPF.hasError("termNotAccepted")) {
      showError(
        "",
        "Você deve concordar com a Política de Privacidade antes de prosseguir."
      );
      return false;
    }

    if (this.formInvestidorPF.invalid) {
      showError(
        "Campos obrigatórios não preenchidos corretamente.",
        "Campos obrigatórios não preenchidos corretamente. Revise o formulário novamente para prosseguir."
      );
      return false;
    }

    return true;
  }

  private validateFormResponsavelEntidade(): boolean {
    if (this.documentoIdentificadorResponsavelEntidade.hasError("cpfInvalid")) {
      showError("", "Infome um CPF Válido.");
      return false;
    }

    if (this.emailResponsavelEntidade.hasError("emailInvalid")) {
      showError("", "Informe um E-mail válido.");
      return false;
    }

    if (this.formResponsavelEntidade.errors?.confirmEmailRequired) {
      showError("", "Confirme o email informado.");
      return false;
    }

    if (this.formResponsavelEntidade.errors?.diffEmails) {
      showError("", "Os emails informados não coincidem.");
      return false;
    }

    if (this.senhaResponsavelEntidade.hasError("invalidPassword")) {
      showError("", "Informe uma senha.");
      return false;
    }

    if (this.senhaResponsavelEntidade.hasError("weakPassword")) {
      showError(
        "",
        "Sua senha precisa ter no mínimo 8 caracteres, 1 letra maiúscula, 1 letra minúscula, 1 caractere especial e 1 número."
      );
      return false;
    }

    if (this.formResponsavelEntidade.errors?.confirmPasswordRequired) {
      showError("", "Confirme sua senha.");
      return false;
    }

    if (this.formResponsavelEntidade.errors?.diffPasswords) {
      showError("", "As senhas informadas não coincidem.");
      return false;
    }

    if (this.termResponsavelEntidade.hasError("termNotAccepted")) {
      showError(
        "",
        "Você deve concordar com a Política de Privacidade antes de prosseguir."
      );
      return false;
    }

    if (this.formResponsavelEntidade.invalid) {
      showError(
        "Campos obrigatórios não preenchidos corretamente.",
        "Campos obrigatórios não preenchidos corretamente. Revise o formulário novamente para prosseguir."
      );
      return false;
    }

    return true;
  }

  private validateFormEntidade(): boolean {
    if (!safeAsign(this.tipoEntidade.value)) {
      showError(
        "Campo Obrigatório",
        "Selecione um tipo de entidade para prosseguir"
      );

      return false;
    }

    if (this.razaoSocial.hasError("required")) {
      showError("", `O campo Razão Social é obrigatório.`);
      return false;
    }

    if (this.razaoSocial.hasError("pattern")) {
      showError("", `O campo Razão Social contém caracteres inválidos.`);
      return false;
    }

    if (this.documentoIdentificadorCNPJ.hasError("cnpjInvalid")) {
      showError("", "Infome um CPF Válido.");
      return false;
    }

    if (this.formEntity.errors?.telOrCellRequired) {
      showError(
        "Telefone ou celular não informado",
        "para prosseguir informe um número de telefone ou de celular"
      );
      return false;
    }

    if (this.dataNascimentoEntidade.invalid) {
      showError("", 'O campo "Data de Nascimento" é obrigatório.');
      return false;
    }

    if (this.formEntity.invalid) {
      showError(
        "Campos obrigatórios não preenchidos corretamente.",
        "Campos obrigatórios não preenchidos corretamente. Revise o formulário novamente para prosseguir."
      );
      return false;
    }

    return true;
  }

  private validateFormEmpresa(): boolean {
    const cnpjs: string[] = [];

    if (!this.tokenValidado) {
      showError(
        "",
        "Você precisa validar o seu email para efetuar o cadastro."
      );
      return false;
    }

    const empresas = this.formEmpresa.get("empresas") as FormArray;

    for (let e = 0; e < empresas.length; e++) {
      const emp = empresas.at(e) as FormGroup;
      const cnpjValue = emp.get("cnpj")?.value;

      // Contêm os valores dos representates de uma determinada empresa.
      const nomes: string[] = [];
      const cpfs: string[] = [];
      const emails: string[] = [];

      // Validação de CNPJ

      let cnpjValido = cnpjValue;

      try {
        cnpjValido = CnpjValidator.create(cnpjValue);
        emp.get("cnpj")?.setValue(cnpjValido);
      } catch {
        showError("", `O CNPJ do Credor Pessoa Jurídica na posição ${e + 1} não é válido.`);
        return false;
      }

      if (cnpjs.includes(cnpjValido)) {
        showError("", `O CNPJ ${cnpj.format(cnpjValido)} está duplicado.`);
        return false;
      }

      cnpjs.push(cnpjValido);

      // Validação de Razão Social
      if (emp.get("nomeEmpresa")?.hasError("required")) {
        showError(
          "",
          `O campo Razão Social do Credor Pessoa Jurídica ${e + 1} é obrigatório.`
        );
        return false;
      }

      if (emp.get("nomeEmpresa")?.hasError("pattern")) {
        showError(
          "",
          `O campo Razão Social do Credor Pessoa Jurídica ${e + 1} contém caracteres inválidos.`
        );
        return false;
      }

      const representantes = emp.get("representantes") as FormArray;
      const emailRegex = /^[A-Za-z0-9._+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/;

      // Validação dos Representantes
      for (let i = 0; i < representantes.length; i++) {
        const rep = representantes.at(i) as FormGroup;
        const nome = rep.get("nome")?.value?.toLowerCase()?.trim();
        const cpfRep = rep.get("cpf")?.value?.trim();
        const emailPj = rep.get("emailPj")?.value?.toLowerCase()?.trim();

        if (i === 0) {
          if (!nome || nome.length === 0) {
            showError(
              "",
              `O nome do Representante Legal ${i + 1} do Credor Pessoa Jurídica ${e + 1} é obrigatório.`
            );
            return false;
          }
          if (!cpfRep || cpfRep.length === 0 || !cpf.isValid(cpfRep)) {
            showError(
              "",
              `O CPF do Representante Legal ${i + 1} do Credor Pessoa Jurídica ${e + 1} é inválido ou não foi preenchido.`
            );
            return false;
          }
          if (!emailPj || emailPj.length === 0) {
            showError(
              "",
              `O email do Representante Legal ${i + 1} do Credor Pessoa Jurídica ${e + 1} é obrigatório.`
            );
            return false;
          }
        }

        if (emailPj && !emailRegex.test(emailPj)) {
          showError(
            "",
            `O email do Representante Legal ${i + 1} do Credor Pessoa Jurídica ${e + 1} é inválido.`
          );
          return false;
        }

        if (cpfRep && !cpf.isValid(cpfRep)) {
          showError(
            "",
            `O CPF do Representante Legal na posição ${i + 1} do Credor Pessoa Jurídica ${
              e + 1
            } é inválido.`
          );
          return false;
        }

        if (cpfRep && cpfs.includes(cpfRep)) {
          showError(
            "",
            `O CPF do Representante Legal "${cpfRep}" na posição ${
              i + 1
            } do Credor Pessoa Jurídica ${e + 1} está duplicado.`
          );
          return false;
        }

        if (cpfRep) cpfs.push(cpfRep);

        if (nome && nomes.includes(nome)) {
          showError(
            "",
            `O nome do Representante Legal "${nome}" na posição ${i + 1} do Credor Pessoa Jurídica ${
              e + 1
            } está duplicado.`
          );
          return false;
        }

        if (nome) nomes.push(nome);

        if (emailPj && emails.includes(emailPj)) {
          showError(
            "",
            `O email do Representante Legal "${emailPj}" na posição ${
              i + 1
            } do Credor Pessoa Jurídica ${e + 1} está duplicado.`
          );
          return false;
        }

        if (emailPj) emails.push(emailPj);
      }
    }

    return true;
  }

  private validateAgeControl(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const birthDateStr = control.value;
      if (!birthDateStr) return null;

      const birthDate = moment(birthDateStr, "YYYY-MM-DD");
      if (!birthDate.isValid()) return { invalidDate: true };

      const today = moment();
      const age = today.diff(birthDate, "years");

      const isOfAge =
        age > 18 ||
        (age === 18 &&
          (today.month() > birthDate.month() ||
            (today.month() === birthDate.month() &&
              today.date() >= birthDate.date())));

      this.maiorDeIdade = isOfAge;
      this.updateResponsavelValidatorsPF();

      return null;
    };
  }

  private updateResponsavelValidatorsPF() {
    const nomeRespCtrl = this.formInvestidorPF.get("nomeResponsavel");
    const docRespCtrl = this.formInvestidorPF.get("documentoResponsavel");

    const incapaz = this.formInvestidorPF.get("incapaz")?.value;

    if (!this.maiorDeIdade || incapaz) {
      nomeRespCtrl?.setValidators([
        Validators.required,
        Validators.minLength(5),
        Validators.maxLength(150),
      ]);
      docRespCtrl?.setValidators([
        Validators.required,
        Validators.minLength(11),
        Validators.maxLength(14),
        cpfValidator,
      ]);
    } else {
      nomeRespCtrl?.clearValidators();
      docRespCtrl?.clearValidators();
    }

    nomeRespCtrl?.updateValueAndValidity();
    docRespCtrl?.updateValueAndValidity();
  }

  // Get & Setter Global
  get token() {
    return this.formToken.get("token");
  }

  // Get & Setter PJ
  get documentoIdentificadorPJ() {
    return this.formInvestidorPJ.get("documentoIdentificador");
  }

  get emailPJ() {
    return this.formInvestidorPJ.get("email");
  }

  get dataNascimentoPJ() {
    return this.formInvestidorPJ.get("dataNascimento");
  }

  get senhaPJ() {
    return this.formInvestidorPJ.get("senha");
  }

  get termPJ() {
    return this.formInvestidorPJ.get("termoAceite");
  }

  get empresasPJ(): FormArray {
    return this.formEmpresa.get("empresas") as FormArray;
  }

  // Get & Setter PF
  get documentoIdentificadorPF() {
    return this.formInvestidorPF.get("documentoIdentificador");
  }

  get emailPF() {
    return this.formInvestidorPF.get("email");
  }

  get dataNascimentoPF() {
    return this.formInvestidorPF.get("dataNascimento");
  }

  get incapazPF() {
    return this.formInvestidorPF.get("incapaz");
  }

  get documentoResponsavelPF() {
    return this.formInvestidorPF.get("documentoResponsavel");
  }

  get nomeResponsavelPF() {
    return this.formInvestidorPF.get("nomeResponsavel");
  }

  get senhaPF() {
    return this.formInvestidorPF.get("senha");
  }

  get termPF() {
    return this.formInvestidorPF.get("termoAceite");
  }

  // Get & Setter Entidade
  get documentoIdentificadorResponsavelEntidade() {
    return this.formResponsavelEntidade.get("documentoIdentificador");
  }

  get emailResponsavelEntidade() {
    return this.formResponsavelEntidade.get("email");
  }

  get senhaResponsavelEntidade() {
    return this.formResponsavelEntidade.get("senha");
  }

  get termResponsavelEntidade() {
    return this.formResponsavelEntidade.get("termoAceite");
  }

  get dataNascimentoEntidade() {
    return this.formResponsavelEntidade.get("dataNascimento");
  }

  get tipoEntidade() {
    return this.formEntity.get("tipoEntidade");
  }

  get documentoIdentificadorCNPJ() {
    return this.formEntity.get("documentoIdentificador");
  }

  get razaoSocial() {
    return this.formEntity.get("razaoSocial");
  }
}
